const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getSessionId = () => {
    let id = localStorage.getItem("wbs_analytics_session");
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem("wbs_analytics_session", id);
    }
    return id;
};

export const track = (type, extra = {}) => {
    fetch(`${API}/analytics/event`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: getSessionId(), type, ...extra }),
    }).catch(() => {});
};
